import {
  Stack,
  TextField,
  type TextFieldProps,
  Typography,
  styled,
} from "@mui/material";
import { type ForwardedRef, forwardRef } from "react";

const StyledBaseTextField = styled(TextField)(({ disabled, error }) => ({
  "&": {
    flexGrow: 1,
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    backgroundColor: disabled ? "#F2F3F3" : error ? "#FEF4F2" : "white",
    color: error ? "#EA583B" : "grey.900",
  },
  "& .MuiOutlinedInput-input": {
    boarderRadius: "12px",
  },
}));

export type BaseTextFieldProps = Pick<
  TextFieldProps,
  | "value"
  | "label"
  | "type"
  | "variant"
  | "disabled"
  | "multiline"
  | "rows"
  | "size"
  | "placeholder"
  | "error"
  | "helperText"
  | "sx"
  | "slotProps"
  | "fullWidth"
  | "onClick"
  | "onChange"
  | "onBlur"
> & {
  unit?: string;
};
export const BaseTextField = forwardRef(
  (props: BaseTextFieldProps, ref: ForwardedRef<HTMLDivElement>) => {
    const { helperText, unit, sx, ...restProps } = props;
    return (
      <Stack ref={ref} spacing={0.5} sx={sx}>
        <Stack direction="row" alignItems="flex-end" spacing={1}>
          <StyledBaseTextField {...restProps} value={props.value ?? ""} />
          {unit && <Typography variant="caption">{unit}</Typography>}
        </Stack>
        {helperText && (
          <Typography
            variant="caption"
            sx={{
              color: props.error ? "error.main" : "grey.500",
            }}
          >
            {helperText}
          </Typography>
        )}
      </Stack>
    );
  },
);
